// Centralised, SEO-optimised meta titles & descriptions (EN + AR) per public page.
// Base titles are concise; the " | MENAGroupFX" brand suffix is appended by useSeo.
export const SITE_URL = "https://menagroupfx.com";

export const SEO_META = {
  home: {
    path: "/",
    en: {
      title: "Forex Introducing Broker & Global Market Access",
      description:
        "MENAGroupFX is an Introducing Broker linking traders to regulated brokers across forex, commodities, indices and shares — with education and expert support.",
    },
    ar: {
      title: "وسيط معرّف للفوركس والأسواق العالمية",
      description:
        "MENAGroupFX وسيط معرّف يربط المتداولين بوسطاء منظّمين عبر الفوركس والسلع والمؤشرات والأسهم، مع تعليم ودعم احترافي للوصول إلى الأسواق العالمية.",
    },
  },
  about: {
    path: "/about-us",
    en: {
      title: "About Us — Your Forex Introducing Broker",
      description:
        "Learn how MENAGroupFX works as an Introducing Broker, connecting traders with carefully selected, regulated brokerage partners across global financial markets.",
    },
    ar: {
      title: "من نحن — وسيطك المعرّف للفوركس",
      description:
        "تعرّف على كيفية عمل MENAGroupFX كوسيط معرّف يربط المتداولين بوسطاء منظّمين مختارين بعناية عبر الأسواق المالية العالمية.",
    },
  },
  why: {
    path: "/why-menagroupfx",
    en: {
      title: "Why Trade With an Introducing Broker",
      description:
        "Discover why traders choose MENAGroupFX — careful broker selection, market intelligence, education and dedicated support between you and the global markets.",
    },
    ar: {
      title: "لماذا التداول عبر وسيط معرّف",
      description:
        "اكتشف لماذا يختار المتداولون MENAGroupFX: اختيار دقيق للوسطاء وذكاء للسوق وتعليم ودعم مخصص كطبقة موثوقة بينك وبين الأسواق.",
    },
  },
  markets: {
    path: "/markets",
    en: {
      title: "Trade Forex, Commodities, Indices & Shares",
      description:
        "Access global financial markets through MENAGroupFX brokerage partners — trade forex, commodities, indices and shares with professional platforms and support.",
    },
    ar: {
      title: "تداول الفوركس والسلع والمؤشرات والأسهم",
      description:
        "الوصول للأسواق المالية العالمية عبر شركاء MENAGroupFX — تداول الفوركس والسلع والمؤشرات والأسهم بمنصات احترافية ودعم متخصص.",
    },
  },
  tradingPlatforms: {
    path: "/trading-platforms",
    en: {
      title: "MetaTrader 4 & 5 Trading Platforms",
      description:
        "Explore professional trading platforms including MetaTrader 4 and MetaTrader 5, offered by MENAGroupFX brokerage partners for desktop, web and mobile trading.",
    },
    ar: {
      title: "منصتا التداول ميتاتريدر 4 و5",
      description:
        "استكشف منصات تداول احترافية تشمل ميتاتريدر 4 و5 المقدمة من شركاء MENAGroupFX للتداول عبر سطح المكتب والويب والجوال.",
    },
  },
  accounts: {
    path: "/account-solutions",
    en: {
      title: "Forex Account Types & Solutions",
      description:
        "Compare forex account types offered by MENAGroupFX brokerage partners — standard, raw spread, professional and Islamic accounts to match your trading style.",
    },
    ar: {
      title: "أنواع حسابات الفوركس وحلولها",
      description:
        "قارن أنواع حسابات الفوركس المقدمة من شركاء MENAGroupFX — قياسي وسبريد خام واحترافي وإسلامي لتناسب أسلوب تداولك.",
    },
  },
  brokerPartners: {
    path: "/broker-partners",
    en: {
      title: "Compare Regulated Forex Broker Partners",
      description:
        "Compare regulated forex broker partners by markets, platforms, account types and jurisdiction. Find the right brokerage solution with MENAGroupFX.",
    },
    ar: {
      title: "قارن وسطاء الفوركس المنظّمين الشركاء",
      description:
        "قارن وسطاء الفوركس المنظّمين حسب الأسواق والمنصات وأنواع الحسابات والولاية القضائية، واعثر على حل الوساطة المناسب مع MENAGroupFX.",
    },
  },
  analysis: {
    path: "/market-analysis",
    en: {
      title: "Daily Forex Market Analysis & Insights",
      description:
        "Read daily forex market analysis with technical and fundamental insights on gold, currencies, commodities and indices from the MENAGroupFX research desk.",
    },
    ar: {
      title: "تحليل أسواق الفوركس اليومي ورؤاه",
      description:
        "اقرأ تحليلات أسواق الفوركس اليومية ورؤى فنية وأساسية حول الذهب والعملات والسلع والمؤشرات من فريق أبحاث MENAGroupFX.",
    },
  },
  calendar: {
    path: "/economic-calendar",
    en: {
      title: "Forex Economic Calendar — Live Events",
      description:
        "Track high-impact economic events, central-bank decisions and data releases that move forex and global markets with the MENAGroupFX economic calendar.",
    },
    ar: {
      title: "المفكرة الاقتصادية للفوركس — الأحداث",
      description:
        "تابع الأحداث الاقتصادية عالية الأثر وقرارات البنوك المركزية والبيانات التي تحرّك الفوركس والأسواق العالمية عبر مفكرة MENAGroupFX.",
    },
  },
  education: {
    path: "/education",
    en: {
      title: "Free Forex Trading Education & Courses",
      description:
        "Build your trading knowledge with free forex education from MENAGroupFX — market basics, technical and fundamental analysis, risk management and strategy.",
    },
    ar: {
      title: "تعليم تداول الفوركس المجاني ودوراته",
      description:
        "طوّر معرفتك بالتداول مع تعليم فوركس مجاني من MENAGroupFX — أساسيات الأسواق والتحليل الفني والأساسي وإدارة المخاطر والاستراتيجية.",
    },
  },
  partners: {
    path: "/partners",
    en: {
      title: "Forex IB & Affiliate Partnership Program",
      description:
        "Grow your business with the MENAGroupFX partnership program for introducing brokers, affiliates, educators and trading communities. Transparent commissions.",
    },
    ar: {
      title: "برنامج شراكة الوسطاء والمسوّقين بالعمولة",
      description:
        "طوّر أعمالك مع برنامج شراكة MENAGroupFX للوسطاء المعرّفين والمسوّقين بالعمولة والمعلّمين ومجتمعات التداول، بعمولات شفافة.",
    },
  },
  become: {
    path: "/become-a-partner",
    en: {
      title: "Become a Forex IB Partner — Apply Now",
      description:
        "Apply to join the MENAGroupFX partnership program. Become an introducing broker or affiliate and earn through transparent, tracked referral commissions.",
    },
    ar: {
      title: "كن شريك وسيط معرّف — قدّم الآن",
      description:
        "قدّم للانضمام لبرنامج شراكة MENAGroupFX. كن وسيطاً معرّفاً أو مسوّقاً بالعمولة واكسب عبر عمولات إحالة شفافة ومتتبَّعة.",
    },
  },
  faq: {
    path: "/faq",
    en: {
      title: "Forex Trading FAQ — Common Questions",
      description:
        "Find answers about how MENAGroupFX works as an Introducing Broker — accounts, trading, platforms, broker partners and partnership questions explained.",
    },
    ar: {
      title: "الأسئلة الشائعة عن تداول الفوركس",
      description:
        "اعثر على إجابات حول كيفية عمل MENAGroupFX كوسيط معرّف — الحسابات والتداول والمنصات والوسطاء الشركاء وأسئلة الشراكة.",
    },
  },
  contact: {
    path: "/contact",
    en: {
      title: "Contact Us — Support & Enquiries",
      description:
        "Get in touch with MENAGroupFX for trading account guidance, broker information or partnership enquiries. Our team is ready to help you access the markets.",
    },
    ar: {
      title: "اتصل بنا — الدعم والاستفسارات",
      description:
        "تواصل مع MENAGroupFX للحصول على إرشاد حساب التداول أو معلومات الوسطاء أو استفسارات الشراكة. فريقنا جاهز لمساعدتك على الوصول للأسواق.",
    },
  },
  legal: {
    path: "/legal",
    en: {
      title: "Legal & Regulatory Documents",
      description:
        "Review MENAGroupFX legal and regulatory documents, including risk disclosure, privacy policy, terms and conditions, and cookie and complaints policies.",
    },
    ar: {
      title: "المستندات القانونية والتنظيمية",
      description:
        "راجع مستندات MENAGroupFX القانونية والتنظيمية، بما في ذلك الإفصاح عن المخاطر وسياسة الخصوصية والشروط والأحكام وسياسات ملفات الارتباط والشكاوى.",
    },
  },
  search: {
    path: "/search",
    en: {
      title: "Search",
      description: "Search across market analysis, education, broker partners and FAQs on MENAGroupFX.",
    },
    ar: {
      title: "بحث",
      description: "ابحث في تحليل الأسواق والتعليم والوسطاء الشركاء والأسئلة الشائعة على MENAGroupFX.",
    },
  },
};
